import React from 'react';
import { Link } from 'react-router-dom';

const RecognitionQuote = () => {

  return (
    <section className="bg-gray-100">
      <div className="pt-12">
        <div className="max-w-5xl mx-auto px-6 lg:px-8 pb-12">
          <div className="bg-white p-8 rounded-xl shadow-sm border border-apple-gray-200 mb-12">
            <div className="text-center">
              <div className="bg-apple-gray-700 rounded-full p-4 w-fit mx-auto mb-6">
                <svg className="w-8 h-8 text-white" fill="currentColor" viewBox="0 0 24 24">
                  <path d="M14.017 21v-7.391c0-5.704 3.731-9.57 8.983-10.609l.995 2.151c-2.432.917-3.995 3.638-3.995 5.849h4v10h-9.983zm-14.017 0v-7.391c0-5.704 3.748-9.57 9-10.609l.996 2.151c-2.433.917-3.996 3.638-3.996 5.849h4v10h-10z" />
                </svg>
              </div>
              <blockquote className="text-xl md:text-2xl text-apple-gray-700 font-medium mb-4 leading-relaxed">
                "This recognition represents the collective impact we can achieve when academia and industry work together to shape the next generation of software engineers."
              </blockquote>
              <cite className="text-apple-gray-700 font-semibold">— Charly Cardeño</cite>
            </div>
          </div>

          {/* Back to Home */}
          <div className="text-center">
            <Link
              to="/"
              className="inline-flex items-center px-6 py-3 bg-apple-gray-700 text-white font-medium rounded-lg hover:bg-apple-gray-800 transition duration-300"
            >
              <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 mr-2" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M10 19l-7-7m0 0l7-7m-7 7h14" />
              </svg>
              Back to Home
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
};

export default RecognitionQuote;